import ProductSetItemModel from '../models/product_set_item';
import { getMediaImageUrl } from '../../../utils/img';
import { getSlModal } from '../../sl_modal';
import { editIcon } from '../icons';
import './index.scss';

export class ProductSetPickerSelected extends HTMLElement {
  constructor() {
    super();
    this.onEventsBind = this.onEvents.bind(this);
    this.model = {};
  }
  get needRenderData() {
    const { currentSelectedNum, hasVariationsChildProduct } = this.model;
    return hasVariationsChildProduct && currentSelectedNum > 0;
  }
  connectedCallback() {
    this.bindEvents();
  }
  disconnectedCallback() {
    this.removeEventsListener();
  }
  bindEvents() {
    this.addEventListener('click', this.onEventsBind);
  }
  removeEventsListener() {
    this.removeEventListener('click', this.onEventsBind);
  }
  onEvents(event) {
    if (event.target.closest('.js-scroll-to-product')) {
      this.onScrollToProductPicker(event);
      return;
    }
    if (event.target.closest('.js-close-product-set-selected-modal')) {
      this.onClose();
    }
  }
  onScrollToProductPicker(event) {
    const { product } = this.model;
    const productId = event.target
      .closest('[data-product-id]')
      ?.getAttribute?.('data-product-id');

    if (!productId) {
      return;
    }
    const $productPicker = document.querySelector(
      `product-set-item-picker[data-product-id="${productId}"]`,
    );

    getSlModal(product._id)
      ?.querySelector('product-set-picker-column-layout')
      ?.scrollToElement?.($productPicker);

    getSlModal('product-set-picker-selected-modal')?.onHide?.();
  }
  onClose() {
    this.closest('sl-modal').onHide();
  }
  updateModel(model) {
    this.model = model;
    this.render();
  }
  getChildProductSelectedTemplate(childProductSelected) {
    const { childProductsMap } = this.model;
    const { selectedNum, selectedVariationsNum = {} } = childProductSelected;
    const childProduct = childProductsMap[childProductSelected.id];

    if (!childProduct) {
      return '';
    }

    const childProductModel = new ProductSetItemModel(childProduct);
    const { hasVariations } = childProductModel;
    const { media } = childProduct;

    const vantionKeys = Object.keys(selectedVariationsNum);

    if (!selectedNum) {
      return '';
    }

    const editContainer = hasVariations
      ? `<span class="icon js-scroll-to-product">${editIcon}</span>`
      : '';

    return `
      <div class="product-set-picker-selected__item" data-product-id="${
        childProductSelected.id
      }">
        <div class="product-set-picker-selected__item-title">
          <span class="name">${window.shopline.translateModel(
            childProduct.title_translations,
          )}</span>
          ${editContainer}
        </div>
        ${
          hasVariations
            ? vantionKeys
                .map((vantionKey) => {
                  const variant = childProductModel.variantsMap[vantionKey];
                  const { fields = [] } = variant;
                  return `<div class="product-set-picker-selected__variant">
                      <img src="${getMediaImageUrl(media[0])}">
                      <p>
                        <span class="name">${fields
                          .map((field) =>
                            window.shopline.translateModel(
                              field.name_translations,
                            ),
                          )
                          .join('/')}</span>
                        <span>X${selectedVariationsNum[vantionKey]}</span>
                      </p>
                    </div>`;
                })
                .join('')
            : `<div class="product-set-picker-selected__variant">
                  <img src="${getMediaImageUrl(media[0])}">
                  <p>
                    <span>X${selectedNum}</span>
                  </p>
                </div>`
        }
      </div>
    `;
  }
  render() {
    this.renderContainer();
    if (this.needRenderData) {
      this.renderInfo();
      this.renderItems();
    }
  }
  renderContainer() {
    const { currentSelectedNum, hasVariationsChildProduct } = this.model;
    if (!hasVariationsChildProduct || currentSelectedNum === 0) {
      this.innerHTML = '';
      return;
    }
    if (this.querySelector('.sl-column-layout')) {
      return;
    }
    const template = `
      <div class="product-set-picker-selected__wrap">
        <div class="sl-column-layout">
          <div class="product-set-picker-selected__modal-title">
            <span class="title"></span>
            <span class="js-close-product-set-selected-modal icon-close-container">
              <svg class="icons icon_close">
                <use xlink:href="#icon-close"></use>
              </svg>
            <span>
          </div>
          <div class="sl-column-layout__content product-set-picker-selected__content">
            <div class="product-set-picker-selected__info">
              <div class="product-set-picker-selected__title"></div>
            </div>
            <product-set-picker-payment></product-set-picker-payment>
            <div class="product-set-picker-selected__items"></div>
          </div>
          ${this.initRenderFooter()}
        </div>
      </div>
    `;
    this.innerHTML = template;
  }
  initRenderFooter() {
    if (getSlModal('product-set-picker-selected-modal')) {
      return '<product-set-picker-footer></product-set-picker-footer>';
    }
    return '';
  }
  renderInfo() {
    const { product } = this.model;
    const { media, title_translations } = product;
    if (
      this.querySelector('.product-set-picker-selected__title').children
        .length === 0
    ) {
      this.querySelector('.product-set-picker-selected__title').innerHTML = `
        <img src="${getMediaImageUrl(media[0])}" />
        <span>${window.shopline.translateModel(title_translations)}</span>
      `;
    }
    this.querySelector(
      '.product-set-picker-selected__modal-title span',
    ).innerHTML = this.computedSelectedTip();
  }
  renderItems() {
    const { selected = {} } = this.model;

    this.querySelector('.product-set-picker-selected__items').innerHTML = `
      <div class="product-set-picker-selected__block-name">${window.shopline.i18next.t(
        'Seleted items',
        { ns: 'translation' },
      )}</div>
      <div class="product-set-picker-selected__tip">${this.computedSelectedTip()}</div>
      ${Object.keys(selected)
        .map((productId) =>
          this.getChildProductSelectedTemplate(selected[productId]),
        )
        .join('')}
    `;
  }
  computedSelectedTip() {
    const { mustSelectNum, currentSelectedNum, finishSelected } = this.model;
    const needRequired = mustSelectNum - currentSelectedNum;
    if (finishSelected) {
      return window.shopline.i18next.t(
        `Congratulations! You've unlocked the Product Set discount`,
        { ns: 'translation' },
      );
    }
    return window.shopline.i18next.t(
      'more items to unlock the Product Set discount',
      { ns: 'translation', n: needRequired },
    );
  }
}

if (!customElements.get('product-set-picker-selected')) {
  customElements.define(
    'product-set-picker-selected',
    ProductSetPickerSelected,
  );
}
